import axios from "axios";

export default {
    namespaced: true,
    state: {
        loadingContratos: false,
        contratos: [],
        estadoContratos: [],
    },
    mutations: {
        SET_CONTRATOS(state, contratos) {
            state.contratos = null;
            state.contratos = contratos;
        },
        SET_LOADING_CONTRATOS(state, loading) {
            state.loadingContratos = loading
        },
        SET_ESTADO_CONTRATOS_CLIENTE(state, estadoContratos){
            state.estadoContratos = estadoContratos;
        }
    },
    actions: {
        getContratosDisponibles({
            commit,
            dispatch
        }, bolsa) {
            commit('SET_CONTRATOS', []);
            commit('SET_LOADING_CONTRATOS', true);
            axios
                .get(`api/contratos`, {
                    params: {
                        bolsa: bolsa
                    }
                })
                .then((res) => {
                    let contratos = res.data.map((item) => {
                        return {
                            value: item.id,
                            text: item.contrato,
                            bolsa: item.bolsa
                        };
                    });
                    // console.log(contratos);
                    commit('SET_CONTRATOS', contratos)
                })
                .catch((err) => {
                    console.log(err);
                    dispatch('setSnackbar', {
                        tipo: "error",
                        mensaje: "Error. No se han podido recuperar los contratos",
                    });
                })
                .finally(() => {
                    commit('SET_LOADING_CONTRATOS', false);
                });
        },
        getEstadoContratosCliente({commit}, [fechaRegistro, codCliente]) {
            let params = {
              'fechaRegistro': fechaRegistro,
              'codCliente': codCliente
            }
            let contratosCliente = [];
            return axios.get('api/asientos', {params}).then(respuesta => {
                respuesta.data.forEach(contrato => {
                    contratosCliente.push({
                        contrato_id: contrato.id,
                        contrato: contrato.contrato,
                        activo: contrato.activo,
                        horas: contrato.horas,
                        horasContratadas: contrato.horasContratadas ?? 0,
                        nivelAlertaContrato: contrato.nivelAlertaContrato
                    });
                });
                commit('SET_ESTADO_CONTRATOS_CLIENTE', contratosCliente);
            }).catch((err) => {
                console.log(err);
                dispatch('setSnackbar', {
                    tipo: "error",
                    mensaje: "Error. No se ha podido recuperar el estado de los contratos",
                });
            });
        },
        setContratosCliente({ commit }, contratos){
            commit('SET_ESTADO_CONTRATOS_CLIENTE', contratos);
        }
    },
    getters: {
        estadoContratos: state => state.estadoContratos,
        contratosDisponibles: state => state.contratos.filter(item => item.bolsa),
        tiposAccion: state => state.contratos,
        loadingContratos: state => state.loadingContratos,
        contratoNameById: (state) => id => {
            const contrato = state.contratos.find(contrato => contrato.id = id)
            return contrato ? contrato.contrato : null
        }
    },
}